import { SET_FACETS_PAGINATION_MODE } from './types'

export const setFacetsPaginationMode = (paginationMode: string): { type: typeof SET_FACETS_PAGINATION_MODE, paginationMode: string } => ({
  type: SET_FACETS_PAGINATION_MODE,
  paginationMode
})
